export default __webpack_public_path__ + "static/media/ugo-inlet.fcf90f6c.svg";